import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

export const Id = pipe(
	string,
	parse((s) =>
		s.startsWith(`material:`) ? success(s) : failure(s, 'Invalid wholehouse material id')
	)
);
